import Ajax from "./Ajax"
const BasicPropertyList = async() => {
    const response = await Ajax({
        url: `/product/basicList?limit=false`,
        token: true
    })
    return response.data.result
}
export default BasicPropertyList